var map = {
	"./account/routes.js": 33601,
	"./authentication/routes.js": 33683,
	"./dashboard/routes.js": 31849,
	"./device/routes.js": 84620,
	"./message-center/routes.js": 20594,
	"./shell/routes.js": 63736
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99390;